module.exports = __webpack_public_path__ + "static/img/检验报告@3x.5345fed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/检验报告@3x.png
// module id = 765
// module chunks = 358